import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { SetCookie } from "../../exports/CookieManagement";
import "../../css/AdminManagement/AdminLogin.css";
import { BarCode, ArrowRight2 } from "../CustomComponents/SwiftIcon/Icons";
import Pulse from "../Loader/Pulse";
import { COLOR_VARS } from "../../exports/ColorVars";
import AccessHeader from "../AccessManagement/AccessHeader";

const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [otp, setOTP] = useState("");
  const [timer, setTimer] = useState(0);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOTPError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOTPSent] = useState(false);
  const [login, setLogin] = useState(false);

  useEffect(() => {
    const counter = timer > 0 && setInterval(() => setTimer(timer - 1), 1000);
    return () => clearInterval(counter);
  }, [timer]);

  function sendOTP() {
    if (timer > 0) {
      return;
    }

    if (email === "") {
      setEmailError("Please enter valid email address");
      setOTPError("");
    } else {
      setLoading(true);

      axios
        .post(
          `${REQUEST_BASE_URL}/access/sendotp?email=${email}&role=SUPERADMIN`
        )
        .then((response) => {
          const data = response.data;
          if (data.status === "success") {
            setEmailError("");
            setOTPError("");
            setLoading(false);
            setOTPSent(true);
            setTimer(30);
          } else {
            setEmailError("Account does not exists");
            setOTPError("");
            setLoading(false);
          }
        })
        .catch((error) => {
          setEmailError("Something went wrong!");
          setOTPError("");
          setLoading(false);
        });
    }
  }

  function validateOtp() {
    if (otp === "") {
      setEmailError("");
      setOTPError("Please enter otp");
    } else {
      setLoading(true);

      axios
        .post(
          `${REQUEST_BASE_URL}/access/validateotp?email=${email}&otp=${otp}&type=ADMIN`
        )
        .then((response) => {
          const data = response.data;

          // console.log(data)
          if (!data.error) {
            setEmailError("");
            setOTPError("");
            setOTPSent(true);
            setLoading(false);
            setLogin(true);

            SetCookie("admin_token", data.token);
          } else {
            setEmailError("");
            setOTPError("Entered otp is invalid");
            setLoading(false);
          }
        })
        .catch((error) => {
          setEmailError("");
          setOTPError("Something went wrong!");
          setLoading(false);
        });
    }
  }

  function emailKeyUp(e) {
    if (e.key === "Enter") {
      sendOTP();
    }
  }

  function otpKeyUp(e) {
    if (e.key === "Enter") {
      validateOtp();
    }
  }

  if (login) {
    return <Navigate to="/admin/dashboard" />;
  }

  return (
    <div className="admin-login">
      <div className="login-popup-wrapper">
        {loading ? (
          <>
            <div className="popup-loader">
              <Pulse />
            </div>
          </>
        ) : (
          <>
            <div className="login-header">
              <AccessHeader header_text="Admin Login" />
            </div>
            <div className="login-content">
              <div className="login-body">
                <div className="swift-input-box">
                  <p>Email</p>
                  <input
                    className="swift-input"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    onKeyUp={emailKeyUp}
                    placeholder="Your email address"
                  />
                  <p
                    className={
                      emailError === "" ? "error-text hide" : "error-text"
                    }
                  >
                    {emailError}
                  </p>
                </div>
                <div className="swift-button-icon" onClick={sendOTP}>
                  <div className="button-icon">
                    <BarCode size={20} color={COLOR_VARS["SWIFT_COLOR6"]} />
                  </div>
                  <p>Generate OTP</p>
                </div>
                {otpSent && (
                  <>
                    {timer === 0 ? (
                      <>
                        <p className="resend-otp-button" onClick={sendOTP}>
                          Resend OTP
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="resend-message">
                          Please wait {timer} seconds to resend
                        </p>
                      </>
                    )}
                    
                    <div className="swift-input-box">
                      <p>OTP</p>
                      <input
                        className="swift-input"
                        value={otp}
                        placeholder="123456"
                        maxLength={6}
                        onChange={(e) => {
                          setOTP(e.target.value.replace(/[^\d]/g, ""));
                        }}
                        onKeyUp={otpKeyUp}
                      />
                      <p
                        className={
                          otpError === "" ? "error-text hide" : "error-text"
                        }
                      >
                        {otpError}
                      </p>
                    </div>
                  </>
                )}
              </div>
              {otpSent && (
                <>
                  <div className="login-footer">
                    <div className="swift-button-icon" onClick={validateOtp}>
                      <div className="button-icon">
                        <ArrowRight2
                          size={20}
                          color={COLOR_VARS["SWIFT_COLOR8"]}
                        />
                      </div>
                      <p>Submit</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
